




























































































import Vue from 'vue';

export default Vue.extend({
  name: 'AppBar',
  data: () => {
    return {
      localeModal: false,
      burgerOpen: false,
    };
  },
});
